'use client';

import PickAge from '../../../../../public/images/tests/pick-age.svg';

type Props = {
    items: any[];
    selected?: string;
    onSelect?: (selected: string) => void;
};

export default function AgeCategorySelection({ items, selected, onSelect }: Props) {
    return (
        <div id="age-category-selection" className="bg-light-yellow container mx-auto my-8 p-4 text-center md:p-8">
            <h2 className="py-4 text-2xl md:py-4 md:text-4xl lg:py-8 lg:text-6xl">Alege categoria de vârstă</h2>
            <PickAge className="mb-8 inline-block w-1/3 md:w-64" />
            <ul className="mx-auto grid grid-cols-2 gap-4 md:grid-cols-4 lg:w-4/5">
                {items.map((item) => (
                    <li
                        key={item.slug}
                        className={`border-primary cursor-pointer border ${
                            selected === item.slug ? 'bg-secondary' : 'bg-white'
                        } p-4`}
                        onClick={() => onSelect?.(item.slug)}>
                        {item.name}
                    </li>
                ))}
            </ul>
        </div>
    );
}
